import { OrcsPage } from '../OrcsPage/OrcsPage'

export const BlackForest = () => {
    return <div>
        <OrcsPage/>
    </div>
}


